// const text = "The WRFC played in its first 7s tournament at Wesleyan last weekend. The Williams College B side (aka. B.B.B) went undefeated in its pool making the semi-finals. Congrats to all who played, and thank you Wesleyan for hosting!"

const text = "The White Dawgs are so back. Home Opener on 9/21 against a University in New Haven!"


// const text = "The WRFC is preparing for its 65th Reunion this spring on April 20th! All Olde Fartes are invited. Click the link in the reunion tab to RSVP."

// in its first 7s tournament at Wesleyan last weekend. The Williams College B side (aka. B.B.B) went undefeated in its pool making the semi-finals. Congrats to all who played, and thank you Wesleyan for hosting!"


export default text;